export const terms = [
  "watch",
  "movie",
  "pelicula",
  "season",
  "peliculas",
  "free",
  "streaming",
  "torrent",
  "hd",
  "filme",
  "film",
  "online",
  "gratis",
  "completa",
]
